export default __webpack_public_path__ + "static/media/WM0380.34I-43155_-25813_0.0078e235.jpg";